import { ITickets } from "models/Ticket";

export interface ErrorState {
  isError: boolean;
  typeError?: string;
  message: string;
  isErrorField?: boolean;
}

export enum EnumErrorCodeRequest {
  GENERIC_ERROR = "generic_error",
  PROTOCOL_NOT_FOUND = "protocol_not_found",
  INVALID_TOKEN = "invalid_token",
  INVALID_VALIDATION = "invalid_validation",
  FIELD_INVALID = "field_invalid"
}
export interface ButtonGridItemProps {
  isActive?: () => boolean;
}

export interface RouteParams {
  protocolId: string;
}

export let credentials = {
  access_token: "",
  pipefy_token: "",
  expires_in: 0,
  refresh_expires_in: 0,
  refresh_token: "",
  token_type: "",
  "not-before-policy": 0,
  session_state: "",
  scope: "",
};

export type ApiResponseProps = {
  message: string;
  isAbleToReassign: boolean;
  isAbleToResendMail: boolean;
  isAbleToValidate: boolean;
  title: string;
  ticket: ITickets;
};
